import { render, staticRenderFns } from "./SubirDocumento.vue?vue&type=template&id=a37a3b08"
import script from "./SubirDocumento.vue?vue&type=script&lang=js"
export * from "./SubirDocumento.vue?vue&type=script&lang=js"
import style0 from "./SubirDocumento.vue?vue&type=style&index=0&id=a37a3b08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports